var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _linearGradient, _path9, _linearGradient2, _path0, _linearGradient3, _path1, _path10, _path11, _path12, _linearGradient4, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1000px",
    height: "1000px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#103262",
    d: "M43.255,23.547l-6.81-3.967v11.594H44v-6.331C44,24.309,43.716,23.816,43.255,23.547z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0084d7",
    d: "M13,10h10v9H13V10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33afec",
    d: "M23,10h10v9H23V10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#54daff",
    d: "M33,10h10v9H33V10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#027ad4",
    d: "M23,19h10v9H23V19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0553a4",
    d: "M23,28h10v9H23V28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#25a2e5",
    d: "M33,19h10v9H33V19z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0262b8",
    d: "M33,28h10v9H33V28z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,24.238 28.99,32.238 13,24.238",
    opacity: 0.019
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,24.476 28.99,32.476 13,24.476",
    opacity: 0.038
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,24.714 28.99,32.714 13,24.714",
    opacity: 0.057
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,24.952 28.99,32.952 13,24.952",
    opacity: 0.076
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,25.19 28.99,33.19 13,25.19",
    opacity: 0.095
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,25.429 28.99,33.429 13,25.429",
    opacity: 0.114
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,25.667 28.99,33.667 13,25.667",
    opacity: 0.133
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,25.905 28.99,33.905 13,25.905",
    opacity: 0.152
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,26.143 28.99,34.143 13,26.143",
    opacity: 0.171
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,26.381 28.99,34.381 13,26.381",
    opacity: 0.191
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,26.619 28.99,34.619 13,26.619",
    opacity: 0.209
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,26.857 28.99,34.857 13,26.857",
    opacity: 0.229
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,27.095 28.99,35.095 13,27.095",
    opacity: 0.248
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,27.333 28.99,35.333 13,27.333",
    opacity: 0.267
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,27.571 28.99,35.571 13,27.571",
    opacity: 0.286
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,27.81 28.99,35.81 13,27.81",
    opacity: 0.305
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,28.048 28.99,36.048 13,28.048",
    opacity: 0.324
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,28.286 28.99,36.286 13,28.286",
    opacity: 0.343
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,28.524 28.99,36.524 13,28.524",
    opacity: 0.362
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,28.762 28.99,36.762 13,28.762",
    opacity: 0.381
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,37 43,37 43,29 28.99,37 13,29",
    opacity: 0.4
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Qf7015RosYe_HpjKeG0QTa",
    x1: 38.925,
    x2: 32.286,
    y1: 24.557,
    y2: 36.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31abec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1582d5"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Qf7015RosYe_HpjKeG0QTa)",
    d: "M15.441,42h26.563c1.104,0,1.999-0.889,2-1.994C44.007,35.485,44,24.843,44,24.843 s-0.007,0.222-1.751,1.212S14.744,41.566,14.744,41.566S14.978,42,15.441,42z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Qf7015RosYe_HpjKeG0QTb",
    x1: 13.665,
    x2: 41.285,
    y1: 6.992,
    y2: 9.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.042,
    stopColor: "#076db4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0461af"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Qf7015RosYe_HpjKeG0QTb)",
    d: "M43,10H13V8c0-1.105,0.895-2,2-2h26c1.105,0,2,0.895,2,2V10z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Qf7015RosYe_HpjKeG0QTc",
    x1: 28.153,
    x2: 23.638,
    y1: 33.218,
    y2: 41.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33acee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b8edf"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Qf7015RosYe_HpjKeG0QTc)",
    d: "M13,25v15c0,1.105,0.895,2,2,2h15h12.004c0.462,0,0.883-0.162,1.221-0.425L13,25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.319,13H13v24h8.319C23.352,37,25,35.352,25,33.319V16.681C25,14.648,23.352,13,21.319,13z",
    opacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.213,36H13V13.333h8.213c1.724,0,3.121,1.397,3.121,3.121v16.425 C24.333,34.603,22.936,36,21.213,36z",
    opacity: 0.07
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.106,35H13V13.667h8.106c1.414,0,2.56,1.146,2.56,2.56V32.44C23.667,33.854,22.52,35,21.106,35z",
    opacity: 0.09
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Qf7015RosYe_HpjKeG0QTd",
    x1: 3.53,
    x2: 22.41,
    y1: 14.53,
    y2: 33.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1784d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0864c5"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Qf7015RosYe_HpjKeG0QTd)",
    d: "M21,34H5c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16 C23,33.105,22.105,34,21,34z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,18.691c-3.111,0-4.985,2.377-4.985,5.309S9.882,29.309,13,29.309 c3.119,0,4.985-2.377,4.985-5.308C17.985,21.068,16.111,18.691,13,18.691z M13,27.517c-1.765,0-2.82-1.574-2.82-3.516 s1.06-3.516,2.82-3.516s2.821,1.575,2.821,3.516S14.764,27.517,13,27.517z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.3bc0c81c8a0dc47616053e7ee1c01be7.svg";
export { ForwardRef as ReactComponent };